export enum Status{
    STUDENT="STUDENT",
    ALUMNUS = "ALUMNUS"
}


export interface EntryData{
name: string;
surname: string;
email: string;
country: string;
university: string;
status: Status;
yearGraduated?: number;
imageUrls?: any[]
}
